import CryptoJS from 'crypto-js';

/**
 * Generates a unique request ID to be used as AES encryption key
 * @returns A 32-character hex string
 */
export function generateRequestId(): string {
  return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
}

/**
 * Encrypts a string using AES-CBC mode
 * @param plainText - The text to encrypt
 * @param key - The encryption key (request_id)
 * @returns Base64 encoded encrypted string
 */
export function encryptAES(plainText: string, key: string): string {
    const keyWordArray = CryptoJS.enc.Utf8.parse(key);
    const iv = CryptoJS.lib.WordArray.random(16); // ← Random IV each time

    const encrypted = CryptoJS.AES.encrypt(plainText, keyWordArray, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    // Prepend IV to ciphertext: "base64(iv):base64(ciphertext)"
    return iv.toString(CryptoJS.enc.Base64) + ':' + encrypted.toString();
  }
